import { useContext, useState } from 'react';
import { useLoadContextEffect } from './useLoadContextEffect';
import { v4 as uuid } from 'uuid';

export const useLoadContext = (context, initialValue) => {
  const [updateId] = useState<string>(uuid());
  const [value, setValue] = useContext(context);

  useLoadContextEffect(setValue, { ...initialValue, updateId });
  const loaded = value.updateId === updateId;

  return [value, setValue, loaded];
};

export default useLoadContext;
